<template>
    <div id="wrapper">
        <div class="row">
            <div class="col">
                <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/CAF_B_BLU.png" style="width:250px"></a>
            </div>
            <div class="col">
                <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/logo_satec.png" style="width:180px;background:#00467f"><!--{{ $route.name }}--></a>
            </div>
        </div>
        <div style="margin-bottom: 100px"></div>
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm" v-if="status == 'true'" style="border-style: solid; border-color: #008000;">
                <p style="color:#000000;font-size:28px">
                  ID pratica: <i>{{id}}</i><br>
                  Status: <i style="color:#008000; text-transform: uppercase;">{{status}}</i>
                </p>
            </div>
            <div v-else class="col-sm" style="border-style: solid; border-color: #FF0000;">
            <p style="color:#000000;font-size:28px">
              ID pratica: <i>{{id}}</i><br>
              Status: <i style="color:#FF0000; text-transform: uppercase;">{{status}}</i>
            </p>
        </div>
            <div class="col-sm"></div>
        </div> 
         <div style="margin-bottom: 100px"></div>
  </div>
</template>
<script>

export default {
  components: {},

  data() {
    return {
     status: false,
     id: null,
    };
  },
  methods: {},

  mounted() {
    this.status = this.$route.query.status
    this.id = this.$route.query.id
    console.log("status = "+this.status + ", id = "+ this.id)
  }
};
</script>
<style>
</style>
